import EntSubs from './modules/00_entitlements';
import MembershipPrice from './modules/01_membership';
import Subscriber from './modules/02_subscriber';

(function($, Drupal) {

  if ($('.page--search').length === 0) {
    if ($('[data-component-id="nuplayer:full_width_page"].rentals').length > 0) {
      if ($('.rentals.header-container [data-component-id="nuplayer:film_hero_carousel"]').length > 0) {
        $('[data-component-id="nuplayer:film_hero_carousel"]').removeClass('initially-hidden').addClass('show-if-non-subscription');
      }

      EntSubs.landingInit('rental');
      MembershipPrice.pageInit('rental');
    }
    else if ($('.page-node-type-home-page').length > 0) {
      EntSubs.landingInit('rental');
      MembershipPrice.pageInit('rental');
    }
  }

  if ($('[data-component-id="nuplayer:full_width_page"].subscription').length > 0) {
    Subscriber.addUserStatusClasses();
  }

  if ($('[data-component-id="nuplayer:full_width_page"].free').length > 0) {
    if ($('.free.header-container [data-component-id="nuplayer:film_hero_carousel"]').length > 0) {
      $('[data-component-id="nuplayer:film_hero_carousel"]').removeClass('initially-hidden').addClass('show-if-non-subscription');
    }
  }

  Drupal.behaviors.nuplayer = {
    EntSubs: EntSubs,
    MembershipPrice: MembershipPrice,
    Subscriber: Subscriber,
  };

})(jQuery, Drupal);
